<div class="text-center" style="padding-top: 35px">
  <div class="lds-ripple"><div></div><div></div></div>
  <br>
  <span>Chargement</span>
</div>
